// extracted by mini-css-extract-plugin
module.exports = {"gallery_heading":"Gallery_gallery_heading__2eZje","fade":"Gallery_fade__3_WHN"};